
import {Component, Vue} from 'vue-property-decorator';
import baseUrl from '@/constants';
import {integrityApi} from "@/api/integrity";
import Credit from "@/views/integrity/Credit.vue";
import {nextTick} from "vue";
import NameOneRowLen from "@/views/integrity/components/nameOneRowLen.vue";
import ImgUploadOneOnline from "@/views/integrity/imgUploadOneOnline.vue";
@Component({
  components: {ImgUploadOneOnline, NameOneRowLen, Credit}
})
export default class applyDialog extends Vue {
  private showOrderDialog = false; // 是否展示弹框
  private dialogData = null as any;
  form = {
    filingNo: "",
    ownerName: "",
    launchTime: "",
    userName: "",
    userMobile: "",
    promise: false,  //自我承诺勾选
    examineStatus: '', // 审核状态
    examineReason: '', // 拒绝原因
  }
  private rules = {
    examineStatus: [{required: true, message: '请选择审核状态', trigger: 'change'}],
    examineReason: [{required: true, message: '请输入内容', trigger: 'blur'}],
  }
  private currentOrgId = "";
  private showDetailDialog = false;
  private show = 'show'; // show edit examine ban 封禁

  // 弹窗保存
  dialogSave(submit: boolean) {
    return new Promise(resolve => {
      const params = Object.assign({}, this.dialogData, {
        statementUrl: (this.$refs.imgUpload1 as any).getData(), // 自我声明
        promiseUrl: (this.$refs.imgUpload2 as any).getData(), // 承诺书
        state: undefined
      });
      integrityApi.addOrUpdate(params).then((r: any) => {
        if (r.data.result === 0) {
          if (!submit) {
            this.$message.success("保存成功");
            this.showOrderDialog = false;
            this.$emit("saveFinish");
          } else {
            resolve(1);
          }
        }
      })
    })
  }

  // 弹窗提交
  dialogSubmit() {
    if (!(this.$refs.imgUpload1 as any).getData() || !(this.$refs.imgUpload2 as any).getData()) {
      this.$alert("请先上传自我声明和承诺书<div style='color: red;'>注意选择图片后，需要手动点击“上传到服务器”按钮</div>", '提示', {
        dangerouslyUseHTMLString: true
      });
      return;
    }
    this.$confirm('确认提交？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.dialogSave(true).then((r: any) => {
        integrityApi.changeState({id: this.dialogData.id, state: 1}).then((r2: any) => {
          if (r2.data.result === 0) {
            this.$message.success("提交成功");
            this.showOrderDialog = false;
            this.$emit("saveFinish");
          }
        })
      })
    }).catch(() => {
      console.log("取消")
    });
  }

  // 审核提交
  dialogExamine() {
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if (valid) {
        this.$confirm("确实要提交?", "确认操作").then(() => {
          integrityApi.changeState({id: this.dialogData.id, state: this.form.examineStatus,reason:this.form.examineReason}).then((r2: any) => {
            if (r2.data.result === 0) {
              if (this.form.examineStatus == '3') {
                // 生成承诺书
                integrityApi.generateSpecialMark({ids: this.dialogData.id, wordNumber: (this.$refs.nameOneRowLen as any).getNumber()}).then((r: any) => {
                  this.$message.success("提交成功");
                  this.showOrderDialog = false;
                  this.$emit("saveFinish");
                })
              } else {
                this.$message.success("提交成功");
                this.showOrderDialog = false;
                this.$emit("saveFinish");
              }
            }
          })
        })
      }
    })
  }

  // 下载自评表  type类别:3自评表，2自我声明，i承诺书，
  downloadTable(type: number, key: string) {
    integrityApi.listFiles({
      industryKey: key,
      type: type
    }).then((r: any) => {
      if (r.data.result === 0) {
        const rData = r.data.data;
        window.open(baseUrl + "/file/download?file=/" + rData[0].filePath , '_blank');
      }
    })
  }

  tableShow() {
    // 显示企业信息弹框
    this.currentOrgId = this.dialogData.orgId;
    this.showDetailDialog = true;
  }

  // 外部调用
  setData(rData: any) {
    this.show = 'edit';
    this.dialogData = rData;
    this.setExamineData(rData);
    this.showOrderDialog = true;
    (this.$refs.imgUpload1 as any)?.handleRemoveCheck();
    (this.$refs.imgUpload2 as any)?.handleRemoveCheck();
  }
  toDetail(row: any, type: string) {
    this.dialogData = row;
    this.setExamineData(row);
    this.showOrderDialog = true;
    this.show = type;

    if (row.statementUrl) {
      this.form.promise = true;
      nextTick(() => {
        (this.$refs.imgUpload1 as any)?.setData(row.statementUrl);
      })
    } else {
      (this.$refs.imgUpload1 as any)?.handleRemoveCheck();
    }
    if (row.promiseUrl) {
      this.form.promise = true;
      nextTick(() => {
        (this.$refs.imgUpload2 as any)?.setData(row.promiseUrl);
      })
    } else {
      (this.$refs.imgUpload2 as any)?.handleRemoveCheck();
    }
  }
  setExamineData(rData: any) {
    if (rData.state) {
      if (rData.state.code == 2) {
        this.form.examineStatus = '2';
      } else if (rData.state.code == 3) {
        this.form.examineStatus = '3';
      } else if (rData.state.code == 5) {
        this.form.examineStatus = '5';
      } else {
        this.form.examineStatus = '';
      }
    } else {
      this.form.examineStatus = '';
    }

    if (rData.reason) {
      this.form.examineReason = rData.reason;
    } else {
      this.form.examineReason = '';
    }
  }

  // 判断未通过原因显示时机
  showReason() {
    let flag = false;
    if (this.form.examineReason && this.show == 'examine' || this.form.examineStatus === '2') {
        flag = true;
    }
    return flag;
  }

  closeDialog() {
    this.showOrderDialog = false;
  }
}
